import ApiService from '@services/api.service'
import { store } from '@state/store'

const ZoneService = {
  async getZonesForSite() {
    let response = await ApiService.get(
      `/Systems/Zones/Site/${store.state.site.siteNumber}`
    ).catch((err) => {
      throw err
    })

    let zones = response.data
    zones.sort((a, b) => {
      let zoneNum1 = parseInt(a.ZoneId)
      let zoneNum2 = parseInt(b.ZoneId)

      // if both zones are numeric, sort in ascending order
      if (!isNaN(zoneNum1) && !isNaN(zoneNum2)) {
        return zoneNum1 - zoneNum2
      }
      // if one zone is numeric and the other is not, list numeric zone first
      if (!isNaN(zoneNum1)) {
        return -1
      }
      if (!isNaN(zoneNum2)) {
        return 1
      }
      // if neither zone is numeric, sort alphabetically
      return a.ZoneId > b.ZoneId ? 1 : a.ZoneId < b.ZoneId ? -1 : 0
    })

    store.updateZones(zones)
  },
}

export default ZoneService
